module.exports = "/app/main/img/extra-meal-v2.1d3678d4.png";